import{ERROR_MESSAGES as e,ERRORS as o,DEVICE_FINGERPRINT as s}from"../../constants.js";const t=t=>({errorCode:t,message:e[t]||e[o.UNKNOWN],type:s});export{t as default};
//# sourceMappingURL=utils.js.map
